import { useState } from 'react';
import dayjs from 'dayjs';

import { calculateDuration, IDuration } from '@mopla/utils';

import { useThrottle } from './useThrottle';

interface ICountdownTimer {
	timerString: IDuration;
	isFinished: boolean;
}
export const useCountdownTimer = (endDate: Date): ICountdownTimer => {
	const [startDate, setStartDate] = useState(dayjs().toDate());
	const [isFinished, setIsFinished] = useState(false);

	const timerString = calculateDuration(startDate, endDate);

	const incrementTimer = () => {
		if (isFinished) return;

		const now = dayjs();
		if (dayjs(now).isSameOrAfter(dayjs(endDate))) {
			setIsFinished(true);
			return;
		}
		setStartDate(now.toDate());
	};

	useThrottle(incrementTimer, 1000);

	return { timerString, isFinished };
};
